<template>
	<page>
		<module :tabs="tabList" enable-flex>
			<m-operate>
				<c-button color="main" @click="editTemplate()">新建模板</c-button>
			</m-operate>
			
			<c-table ref="table" height="grow">
				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">未生效</span>
						<span v-else-if="data.state == 1" style="color:darkgreen">生效中</span>
						<span v-else-if="data.state == 2" style="color:#999">已过期</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="模板名称"
					name="template_name"
					width="280"
				></c-table-column>
				
				<c-table-column
					label="备注"
					name="remark"
					width="300"
				></c-table-column>
				
				<c-table-column
					label="生效时间"
					width="140"
				>
					<template v-slot="{data}">
						<span v-if="data.id > 0 && data.state == 0" style="color:red">{{data.effective_start_date}}</span>
						<span v-if="data.id > 0 && data.state == 1" style="color:darkgreen">{{data.effective_start_date}}</span>
						<span v-if="data.id > 0 && data.state == 2" style="color:#999">{{data.effective_start_date}}</span>
						<span v-if="data.id < 0">--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="210"
				>
					<template #default="{data}">
						<c-table-button @click="navigateTo(`/decorate_manage/${type == 1 ? 'pc' : 'app'}?id=${data.id}`, true)">装修</c-table-button>
						<c-table-button @click="editTemplate(data, true)">复制</c-table-button>
						<c-table-button v-if="data.id > 0" @click="editTemplate(data)">编辑</c-table-button>
						<c-table-button v-if="data.id > 0 && data.state != 1" @click="deleteTemplate(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			
			
			<c-dialog ref="editDialog" width="550" @resolve="editTemplateHandle">
				<c-form ref="editForm" unit-width="100%">
					<c-input type="hidden" name="id"></c-input>
					<c-input type="hidden" name="template_id"></c-input>
					<c-input type="hidden" name="support_flag"></c-input>
					<c-form-item label="模板名称" required tip="请输入模板名称，最多不超过50个字符">
						<c-input name="template_name" maxlength="50"></c-input>
					</c-form-item>
					<c-form-item label="生效时间" required>
						<c-datetime name="effective_start_date"></c-datetime>
					</c-form-item>
					<c-form-item label="备注">
						<c-input type="textarea" name="remark"></c-input>
					</c-form-item>
				</c-form>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		props: {
			tab: String
		},
		
		data() {
			return {
				tabList: [{
				// 	name: 'PC装修',
				// 	value: 1
				// }, {
					name: '移动装修',
					value: 2
				}]
			}
		},
		
		computed: {
			type() {
				return this.tabList[this.tab || 0].value;
			}
		},
		
		watch: {
			type() {
				this.update();
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.$refs.table.load({
					url: '/decoration/template/list',
					data: {
						support_flag: this.type
					}
				});
			},
			
			stateHandle(state, next, data) {
				this.request({
					url: '/freight_template/state',
					data: {
						id: data.id,
						state: state ? 1 : 2
					},
					success: () => {
						next();
					}
				});
			},
			
			editTemplate(data, copy) {
				this._editState = !!data;
				this._copyState = !!copy;
				this.$refs.editForm.clear();
				this.$refs.editForm.set(copy ? {
					support_flag: this.type,
					template_id: data.id
				} : Object.assign(data || {}, {
					support_flag: this.type
				}))
				this.$refs.editDialog.open({
					title: copy ? '复制模板' : data ? '编辑模板' : '新增模板'
				});
			},
			
			editTemplateHandle(stop, next) {
				stop();
				this.$refs.editForm.submit({
					url: this._copyState ? '/decoration/template/copy' : this._editState ? '/decoration/template/edit' : '/decoration/template/add',
					rule: {
						template_name: '请填写模板名称',
						effective_start_date: '请选择模板生效时间'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '保存成功'
						});
						this.update();
					}
				});
			},
			
			deleteTemplate(data) {
				this.$confirm({
					message: `确定要删除运费模板【${data.template_name}】吗？`,
					resolve: () => {
						this.request({
							url: '/decoration/template/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style>
</style>